import React, { CSSProperties, FunctionComponent } from 'react';
import Carousel, { Modal, ModalGateway } from 'react-images';

export interface IGalleryItem {
  index: number;
  caption: string;
  download: boolean;
  ext: string;
  imageIndex?: number;
  src: string;
}

interface IGallery {
  views: IGalleryItem[];
  viewerIsOpen: boolean;
  currentImage: number;
  closeGallery: () => void;
  onViewChange?: (index: number) => void;
}

const modalStyles = {
  blanket: (base: CSSProperties) => ({ ...base, zIndex: 999999 }),
  positioner: (base: CSSProperties) => ({ ...base, zIndex: 1000000 }),
};

const Gallery: FunctionComponent<IGallery> = ({
  views,
  currentImage,
  viewerIsOpen,
  closeGallery,
  onViewChange,
}) => {
  return (
    <ModalGateway>
      {viewerIsOpen && (
        <Modal onClose={closeGallery} styles={modalStyles}>
          <Carousel
            currentIndex={currentImage}
            views={views}
            trackProps={{
              onViewChange,
            }}
          />
        </Modal>
      )}
    </ModalGateway>
  );
};

export default Gallery;
